import React from 'react';

import { PropTypes } from 'prop-types';

import CUI_CONST from './CiscoUIConstants';

const Icon = props => {
  const { icon, size, title, ...other_props } = props;

  let classes = [];

  classes.push(`icon-${icon}`);

  if (size) {
    classes.push(`icon-${size}`);
  }

  return <span className={classes.join(' ')} title={title} {...other_props} />;
};
Icon.defaultProps = {
  icon: '',
  size: null,
  title: null
};

Icon.propTypes = {
  icon: PropTypes.string,
  size: PropTypes.oneOf(CUI_CONST.ICON_SIZES),
  title: PropTypes.string
};

export default Icon;
